import { GetTransactionsFilters } from '@/types/getTransactionsFilters';

export const countTransactionFilters = (
  filters: Partial<GetTransactionsFilters>,
  defaults: GetTransactionsFilters = GetTransactionsFilters.initial(),
): number => {
  return Object.entries(filters).reduce(
    (totalCount: number, [key, value]: [string, unknown]): number => {
      switch (key) {
        case 'id':
        case 'type':
        case 'status':
        case 'fromDate':
        case 'toDate':
        case 'amount':
        case 'currency':
        case 'recipientId':
        case 'beneficiaryId':
          return totalCount + (value === defaults[key as keyof GetTransactionsFilters] ? 0 : 1);
        default:
          return totalCount;
      }
    },
    0,
  );
};
